import { useCallback } from "react";

import { useAppSelector } from "app/redux-store-interactions";
import { WidgetKey } from "config/features";
import { StorageKey } from "config/storage";
import { useCreateBookmark } from "features/bookmarks/useCreateBookmark";
import { selectMaximized, selectMaximizedHorizontal, selectWidgets } from "slices/explorer";
import { saveToStorage } from "utils/storage";

export type PreRefreshState = {
    localBookmarkId: string;
    widgets: WidgetKey[];
    maximized: WidgetKey[];
    maximizedHorizontal: WidgetKey[];
};

export function useRefreshAndRestoreState() {
    const { createUnstableBookmark } = useCreateBookmark();
    const widgets = useAppSelector(selectWidgets);
    const maximized = useAppSelector(selectMaximized);
    const maximizedHorizontal = useAppSelector(selectMaximizedHorizontal);

    return useCallback(() => {
        const bm = createUnstableBookmark();
        const id = window.crypto.randomUUID();
        sessionStorage.setItem(id, JSON.stringify(bm));

        saveToStorage(
            StorageKey.PreRefreshState,
            JSON.stringify({
                localBookmarkId: id,
                widgets,
                maximized,
                maximizedHorizontal,
            } as PreRefreshState),
        );

        window.location.reload();
    }, [createUnstableBookmark, widgets, maximized, maximizedHorizontal]);
}
